import { useEffect } from 'react';

import { useEcho } from '@laravel/echo-react';

import { useAuthSession } from '../hook/auth-session.hook';
import { IUser } from '../types/auth-session.types';

type Props = {
  user: IUser;
};

export const AuthEvents = ({ user }: Props) => {
  const { checkAuth } = useAuthSession();
  const { leave } = useEcho(`App.Auth.${user.id}`, 'NewEvent', () => {
    checkAuth();
  });

  useEffect(() => {
    return () => {
      leave();
    };
  }, []);
  return null;
};
